import { createUrl } from '../../Routing/urls'
import type { SeasonType } from '../../Routing/urls'
import { getAdditionalTeamData } from '../../Utils'
import { PlayerDataGQL } from '../../Api'
import { Season } from './PlayerProfileContext'

export class PlayerURLs {
  constructor(private _player: PlayerDataGQL, private params: Season) {}

  playerProfile(): string {
    return createUrl('player', {
      firstName: this._player.firstName || '',
      lastName: this._player.lastName || '',
      slugName: this._player.slug,
      // year: this._parent.params.year,
      tab: 'profile',
    })
  }
  playerStats(year?: number, season?: SeasonType): string {
    return createUrl('player', {
      firstName: this._player.firstName || '',
      lastName: this._player.lastName || '',
      slugName: this._player.slug,
      year: year || undefined,
      seasonType: season || this.params.seasonType,
      tab: 'stats',
    })
  }
  playerMedia(): string {
    return createUrl('player', {
      firstName: this._player.firstName || '',
      lastName: this._player.lastName || '',
      slugName: this._player.slug,
      tab: 'media',
    })
  }

  // use real player team id
  get teamBanner(): string | null {
    if (this._player.currentTeam) {
      const tdata = getAdditionalTeamData(this._player.currentTeam?.officialId || '')
      return tdata.teamBanner
    } else if (this._player.champSeries?.officialId) {
      const tdata = getAdditionalTeamData(this._player.champSeries.officialId || '')
      return tdata.teamBanner
    } else {
      return null
    }
  }
}
